module.exports = __webpack_public_path__ + "media/images/marketing/video_thumbnail2-c07f13be10e9439367aab744fa0dd92036657aa5e4ce78f0f5ea93cd7cdc4c75.jpg";